import React from 'react';
import { Reveal } from '../ui/Reveal';
import { PARA_TI } from '../../data/retiro';
export function ParaTi() {
  return <section className="w-full px-5 py-24 sm:px-8 sm:py-32" style={{
    backgroundColor: 'var(--ink)'
  }} data-id="element-228" data-mp="158zu6gd2ex2b">
      <div className="mx-auto max-w-5xl" data-id="element-229" data-mp="119912602g4um">
        <Reveal data-id="element-230" data-mp="w9ctxxw2nxau">
          <span className="flex items-center justify-center gap-3 text-xs font-medium uppercase tracking-[0.3em]" style={{
          color: 'var(--jasmine)'
        }} data-id="element-231" data-mp="w9wcngtjqppx">
            <span className="h-px w-8" style={{
            background: 'var(--jasmine)'
          }} data-id="element-232" data-mp="1t1gfczs3n55u" />
            Sin rodeos
          </span>
          <h2 className="mt-6 text-center font-heading text-3xl font-light leading-tight text-white sm:text-5xl" data-id="element-233" data-mp="1k6ihrfe0b486">
            Este viaje es para ti porque{' '}
            <span style={{
            color: 'var(--jasmine)'
          }} data-id="element-234" data-mp="1f6e9gcn95ft1">
              pediste que se te revelaran verdades
            </span>{' '}
             y las revelaciones ya llegaron
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-235" data-mp="2q595kfr3zfal">
            No estás aquí por casualidad, estás aquí por resonancia. Lo que se
            te mostró este año no vino para desordenarte la vida: vino para
            mostrarte de qué tamaño es tu potencial. Y ese tamaño necesita un
            espacio para ser sostenido.
          </p>
        </Reveal>

        <ul className="mt-14 grid gap-4 sm:grid-cols-2" data-id="element-236" data-mp="27e84nm6fh9oe">
          {PARA_TI.map((item, i) => <Reveal key={i} delay={i * 0.08} data-id="element-237" data-mp="2cdkri6xaugqz" data-mpi={i}>
              <li className="flex h-full items-start gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-6" data-id="element-238" data-mp="2cenkcke6mt9j">
                <span className="font-heading text-2xl font-light leading-none" style={{
              color: 'var(--jasmine)'
            }} data-id="element-239" data-mp="1yfw4otjo8zja">
                  0{i + 1}
                </span>
                <p className="text-sm leading-relaxed text-white/85 sm:text-base" data-id="element-240" data-mp="3ssvrb6mgyu02">
                  {item}
                </p>
              </li>
            </Reveal>)}
        </ul>

        <Reveal delay={0.25} data-id="element-241" data-mp="19m1h0wi9l927">
          <p className="mx-auto mt-12 max-w-2xl border-l-2 pl-5 font-heading text-lg font-light italic leading-relaxed text-white/85" style={{
          borderColor: 'var(--jasmine)'
        }} data-id="element-242" data-mp="19j5h52muwab4">
            Si al leer esto algo en tu pecho dijo "sí", esa es la respuesta. El
            resto es logística.
          </p>
        </Reveal>
      </div>
    </section>;
}